module.exports = __webpack_public_path__ + "img/pisa-logo-icon.1184588c.png";